import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ISystemMessagesApi } from "@/api/system-messages";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { SystemMessage, SystemMessagePayload } from "@/models/system-message";
import { useToast } from "@/hooks/use-toast";

interface UpdateSystemMessageArgs {
  id: string;
  payload: Partial<SystemMessagePayload>;
}

export const useUpdateSystemMessage = () => {
  const systemMessagesApi = useInjection<ISystemMessagesApi>(SERVICES_TYPES.SYSTEM_MESSAGES);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateSystemMessageArgs) => systemMessagesApi.update(id, payload),
    onSuccess: (updated) => {
      queryClient.setQueryData<SystemMessage[]>(["system-messages"], (current) =>
        current?.map((item) => (item._id === updated._id ? updated : item))
      );
      toast({ title: "System message updated" });
    },
    onError: (error) => {
      toast({
        title: "Failed to update system message",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
